/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import ValidationUtils = Application.Common.ValidationUtils;
    import Utils = Common.Utils;

    export interface INetworkModalScope extends ng.IScope {
        network: Models.Network;
        isNewNetwork: boolean;
        modalClose: () => void;
        modalSave: () => void;
    }

    /**
     * NetworkModalController class
     */
    export class NetworkModalController {
        public static templateUrl: string = "decorators/modals/network-modal.html";
        public static ID: string = "#id-network-modal";
        public static $name: string = "networkModalController";
        public static $inject: string[] = ['$scope', '$q', 'close', '$timeout', 'network', 'networkService'];

        private $scope: INetworkModalScope;
        private close: (parameters: ngModal.ICloseParameters) => void;
        private static PARSLEY_VALIDATE_NETWORK_NAME: string = "validateNetworkName";
        private originalName: string = undefined;

        /**
         * Constructor
         */
        constructor($scope: INetworkModalScope,
                    private $q: ng.IQService,
                    close: (parameters: ngModal.ICloseParameters) => void,
                    $timeout: ng.ITimeoutService,
                    network: Models.Network,
                    private networkService: Services.NetworkService) {
            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            this.$scope = $scope;
            this.$scope.isNewNetwork = (network === undefined);
            this.close = close;

            this.addParsleyValidateNetworkName();

            if (this.$scope.isNewNetwork) {
                this.$scope.network = Models.Network.Empty();
                this.$scope.network.ipAddress = "0.0.0.0";
                this.$scope.network.subnetMask = "0.0.0.0";
            }
            else {
                this.$scope.network = network;
                this.originalName = network.name;
            }

            this.$scope.modalClose = (): void => {
                this.close(undefined);
            };

            this.$scope.modalSave = async (): Promise<void> => {
                if (await this.isValidName() &&
                    Common.Utils.validateIPAddress(this.$scope.network.ipAddress) &&
                    Common.Utils.validateIPAddress(this.$scope.network.subnetMask)) {
                    this.close(this.$scope.network);
                }
            };
        }

        private addParsleyValidateNetworkName(): void {
            window.Parsley
                .addValidator(NetworkModalController.PARSLEY_VALIDATE_NETWORK_NAME, {
                    validateString: (name: string): boolean => {
                        this.checkUsedName(name).then(usedName =>
                            {
                                ValidationUtils.toggleParsleyWarningClasses('network-name', usedName, "Name");
                            });
                        return true;
                    },
                    messages: {
                        en: name + ` already in use.`,
                    },
                });
        }

        private async isValidName(): Promise<boolean> {
            const notEmpty = this.$scope.network.name != undefined && this.$scope.network.name !== '';
            const isUsed = await this.checkUsedName(this.$scope.network.name);
            return notEmpty && !isUsed;
        }

        private checkUsedName(name: string): ng.IPromise<boolean> {
            if (this.originalName && name && this.originalName === name) {
                return Utils.getBoolPromise(this.$q, false);
            }
            return this.networkService.checkUsedNamePromise(name);
        }
    }
}
